<div class="course-stepper">
  <div class="course-stepper__main">
    <div class="course-stepper__steps">
      @for (step of steps(); track step.id) {
        <div
          class="course-stepper__step"
          [class.course-stepper__step--active]="isStepActive(step.id)"
          [class.course-stepper__step--completed]="isStepCompleted(step.id)"
          [class.course-stepper__step--disabled]="!canNavigateToStep(step.id)"
          (click)="onStepClick(step.id)"
        >
          @if (isStepActive(step.id)) {
            <div class="course-stepper__step-background"></div>
          }
          <div class="course-stepper__step-content">
            <div class="course-stepper__step-icon">
              <img [src]="getStepIcon(step)" [alt]="step.icon" />
            </div>
            <div
              class="course-stepper__step-label"
              [class.course-stepper__step-label--primary]="isStepActive(step.id)"
              [class.course-stepper__step-label--secondary]="!isStepActive(step.id)"
            >
              {{ step.label | translate }}
            </div>
          </div>
        </div>
      }
    </div>

    <!-- <div class="course-stepper__help">
      <div class="course-stepper__step-content">
        <div class="course-stepper__step-icon">
          <div class="course-stepper__icon course-stepper__icon--help"></div>
        </div>
        <div class="course-stepper__step-label course-stepper__step-label--secondary">
          {{ helpStep.label }}
        </div>
      </div>
    </div> -->
  </div>

  <!-- <div class="course-stepper__delete">
    <div class="course-stepper__step-content">
      <div class="course-stepper__step-icon">
        <div class="course-stepper__icon course-stepper__icon--delete"></div>
      </div>
      <div class="course-stepper__step-label course-stepper__step-label--error">
        {{ deleteStep.label }}
      </div>
    </div>
  </div> -->
</div>

